import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatMap, map } from 'rxjs';
import { AuthActions } from '../../../../components/auth/auth.actions';
import { HomeMyRecommendationGeneralHealthActions } from './general-health.actions';
import { HomeMyRecommendationGeneralHealthService } from './general-health.service';

/**
 * @description HomeMyRecommendationGeneralHealth Effects.
 * @exports
 * @class HomeMyRecommendationGeneralHealthEffects
 */
@Injectable()
export class HomeMyRecommendationGeneralHealthEffects extends HomeMyRecommendationGeneralHealthService {
  private readonly actions = inject(Actions);

  readonly onAuthLogin_Activation_SwitchProfile = createEffect(
    () => {
      return this.actions.pipe(
        ofType(
          AuthActions.login,
          AuthActions.activation,
          AuthActions.switchProfile
        ),
        map(() => HomeMyRecommendationGeneralHealthActions.reset()),
        map(() => HomeMyRecommendationGeneralHealthActions.fetch())
      );
    },
    { dispatch: true }
  );

  readonly onAuthLogout = createEffect(
    () => {
      return this.actions.pipe(
        ofType(AuthActions.logout),
        map(() => HomeMyRecommendationGeneralHealthActions.reset())
      );
    },
    { dispatch: true }
  );

  readonly onFetch = createEffect(
    () => {
      return this.actions.pipe(
        ofType(HomeMyRecommendationGeneralHealthActions.fetch),
        concatMap(() => this.recommendations()),
        map(({ results = [] }) =>
          HomeMyRecommendationGeneralHealthActions.setData({ data: results })
        )
      );
    },
    { dispatch: true }
  );
}
